import React from "react";
import { RefundStyleChartCard } from "./RefundChartCard";
import { mergeWishlistModel } from "./dashboardChartsModel";

/**
 * Wishlist — same chart + table + kebab as Refund (row 7, right).
 *
 * @param {object} props
 * @param {import("./dashboardChartsModel.js").CustomOrderChartModel | undefined} [props.model]
 * @param {() => void} [props.onMenuRemove]
 */
function WishlistChartCard({ model, onMenuRemove }) {
  return (
    <RefundStyleChartCard
      model={model}
      onMenuRemove={onMenuRemove}
      mergeModel={mergeWishlistModel}
      titleKey="graphWishlist"
      defaultTitle="Wishlist"
      downloadPrefix="wishlist"
      rowIdPrefix="wl"
      cardBem="wishlist"
    />
  );
}

export default WishlistChartCard;
